import { Grid } from '@material-ui/core';
import { Alert } from "@mui/material";
import CustomInput from "components/CustomInput";
import ActivityTypesField from 'features/activity/ActivityTypesField';
import { useState, useEffect } from 'react';
import { CreateWorkOrderStyles } from '../CreateWorkOrderStyles';

const ActivityType = ({ activity, setActivity, bundleId, setBundleId, customActivity, setCustomActivity, isCustomActivity,  setActivityType, errors, repairOrder, setRepairOrder  }) => {
    const classes = CreateWorkOrderStyles();
    const [selectedValue, setSelectedValue] = useState(null);

    // Reset selectedValue when parent resets activity and bundleId
    useEffect(() => {
        if (!activity && !bundleId) {
            setSelectedValue(null);
        }
    }, [activity, bundleId]);

    const handleSelectChange = (id, metadata) => {
        if (!metadata?.jsonValue) {
            // Handle case when includeBundles is false
            setActivity(id);
            setBundleId(null);
            setActivityType(null);
            setSelectedValue(id);
            return;
        }
        
        const value = JSON.parse(metadata.jsonValue);
        setActivityType(value.activityTypeId);
        setSelectedValue(metadata.jsonValue);
        
        if (!!value.bundleId) {
            setBundleId(value.bundleId);
            setActivity(null);
        } else {
            setActivity(value.activityItemId);
            setBundleId(null);
        }
    };

    return (
        <Grid container direction='row' spacing={1}>
            <Grid item xs={12} className={classes.activityLabel}>
                Activity / Bundle
            </Grid>
            <Grid item xs={12}>
                <ActivityTypesField 
                    onChange={handleSelectChange}
                    value={selectedValue}
                    includeBundles
                    customFields
                    label=""
                    styling={classes.activityDropdown}
                    required={false}
                />
            </Grid>
            {!!errors['activity'] &&
                <Grid xs={12} className={classes.alertWrapper}>
                    <Alert severity='error' >
                        {errors['activity']}
                    </Alert>
                </Grid>}
            {isCustomActivity() && !bundleId && <>
                <Grid item xs={12}>
                    <CustomInput
                        className={classes.otherActivity}
                        id="ddlCustomActivity"
                        label="Custom"
                        elementType="input"
                        value={customActivity}
                        required={true}
                        onChange={val => setCustomActivity(val)}
                    />
                </Grid>
                {!!errors['customActivity'] &&
                    <Grid xs={12} className={classes.alertWrapper}>
                        <Alert severity='error' >
                            {errors['customActivity']}
                        </Alert>
                    </Grid>}
            </>}
            <Grid item xs={12} className={classes.activityLabel}>
                Repair Order
            </Grid>
            <Grid item xs={12}>
                <CustomInput
                    className={classes.otherActivity}
                    id="ddlRepairOrder"
                    elementType="text"
                    value={repairOrder}
                    onChange={(val) => setRepairOrder(val)}
                />
            </Grid>
        </Grid>
    )
}

export default ActivityType;